export default __webpack_public_path__ + "static/media/ad.d4865f62.svg";